export enum Column {
  ENDPOINT_NAME,
  IP,
  COMPANY,
  FILE,
  MODULE,
  THREAT_NAME,
  QUARANTINED,
  ACTION_STATUS,
  FILE_SIZE,
  SELECT
}

export enum ColumnKeys {
  ENDPOINT_NAME = 'source.protectedEntity.name',
  IP = 'source.protectedEntity.ip',
  COMPANY = 'source.company.name',
  FILE = 'source.filePath',
  MODULE = 'module',
  THREAT_NAME = 'threats.name',
  QUARANTINED = 'quarantinedDate',
  ACTION_STATUS = 'actionStatus',
  FILE_SIZE = 'size',
  SELECT = 'select',
}

export const DEFAULT_VISIBLE_COLUMNS: Column[] = [
  Column.ENDPOINT_NAME,
  Column.IP,
  Column.COMPANY,
  Column.FILE,
  Column.THREAT_NAME,
  Column.QUARANTINED,
  Column.ACTION_STATUS,
];


